import { $ } from '../shared/dom';
import { registerSessionSearchUi } from '../session/sessions';

let highlightedSessionId: string | null = null;

function refreshConversationSearchHighlight() {
  const list = $('sessions-list');
  if (!list) return;

  list.querySelectorAll<HTMLElement>('.session-item').forEach((el) => {
    const id = el.dataset.id || null;
    el.classList.toggle('search-selected', highlightedSessionId !== null && id === highlightedSessionId);
  });
}

export function getConversationSearchHighlightedSessionId(): string | null {
  return highlightedSessionId;
}

export function setConversationSearchHighlightedSessionId(id: string | null) {
  highlightedSessionId = id;
  refreshConversationSearchHighlight();
}

export function clearConversationSearch() {
  const input = $<HTMLInputElement>('conversation-search-input');
  if (input) input.value = '';
  const results = $('conversation-search-results');
  if (results) {
    results.classList.add('hidden');
    results.textContent = '';
  }

  setConversationSearchHighlightedSessionId(null);
}

export function setConversationSearchWrapVisible(visible: boolean) {
  const wrap = $('conversation-search-wrap');
  if (!wrap) return;
  wrap.classList.toggle('hidden', !visible);
  if (!visible) clearConversationSearch();
}

// ADR-002 phase C: the session list uses the conversation-search state through this
// registration instead of importing conversation/* from the session capability.
registerSessionSearchUi({
  clear: clearConversationSearch,
  getHighlightedSessionId: getConversationSearchHighlightedSessionId,
  setWrapVisible: setConversationSearchWrapVisible,
});
